import React from "react";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import PeopleIcon from "@mui/icons-material/People";
import WorkspacesIcon from "@mui/icons-material/Workspaces";
import { isDatavisionPosEnabled } from "app/utils/isDatavisionPosEnabled";

/**
 * POS sidebar section (logged-in DSOK customer). Above Access System in "Others".
 * Visible only when Datavision POS is enabled in customer settings.
 */
export function getPosSection(customer) {
  const c = customer || {};
  if (!c.dsok || c.easyPay) return null;
  if (!isDatavisionPosEnabled(c)) return null;

  return {
    label: "sidebar.menu.pos",
    type: "section",
    icon: <PointOfSaleIcon sx={{ fontSize: 20 }} />,
    children: [
      {
        uri: "/customer/dsok/pos/users",
        label: "sidebar.menuItem.posUsers",
        type: "nav-item",
        icon: <PeopleIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/customer/dsok/pos/workspaces",
        label: "sidebar.menuItem.posWorkspaces",
        type: "nav-item",
        icon: <WorkspacesIcon sx={{ fontSize: 20 }} />,
      },
    ],
  };
}
